export default __webpack_public_path__ + "images/a575a0c37af28b74eda5f985a2ee56d5.svg";